import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopLevelFromXp } from "../../selectors/selectCoopInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
export var _RankingPlacementLeagueCoops = function (_a) {
    var ranking = _a.ranking, coopId = _a.coopId;
    var className = "ranking-placement-league";
    var max = ranking.max, players = ranking.players;
    var position = max;
    var renderedCoops = players.map(function (coop, index) {
        var points = coop.points !== undefined ? coop.points.toNumber() : 0;
        var level = selectCoopLevelFromXp(coop.xp || Long.ZERO);
        var selected = coopId.equals(coop.id || Long.NEG_ONE) ? IdStyles.StateSelected : "";
        var key = coop.id ? coop.id : index;
        var renderedElement = (React.createElement("div", { className: IdStyles.TableRowRanking + " " + selected + " flex", key: key.toString() },
            React.createElement("div", { className: className + "__generic-info flex flex--aligned" },
                React.createElement(NumberFormat, { amount: position, className: IdStyles.HeadlineOne }),
                React.createElement("div", { className: className + "__center-icon-text" },
                    React.createElement(Icon, { icon: IdIcon.CoopXpIcn, styleId: IdStyles.IconSmall },
                        React.createElement(NumberFormat, { amount: level, className: IdStyles.TextSmallBoldSecondaryOutline }))),
                React.createElement("span", { className: IdStyles.TextBoldPrimary }, coop.name)),
            React.createElement("div", { className: className + "__score-info flex flex--guts" },
                React.createElement(NumberFormat, { amount: points, className: IdStyles.TextBoldPrimary }))));
        position++;
        return renderedElement;
    });
    return React.createElement("div", { className: "table " + className + "__table" }, renderedCoops);
};
var mapState = function (state) { return ({
    coopId: selectPlayerInfo(state).coopId || Long.ZERO,
}); };
export var RankingPlacementLeagueCoops = connect(mapState)(_RankingPlacementLeagueCoops);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/RankingPlacementLeagueCoops.tsx
// module id = 2800
// module chunks = 3